module.exports = __webpack_public_path__ + "static/media/datasheet_musicData_row0_googleQRcode.482de168.png";